module.exports = __webpack_public_path__ + "static/media/VillaAlemana.813504d5.png";